import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

// Import translation files
import enTranslation from './locales/en.json';
import frTranslation from './locales/fr.json';
import arTranslation from './locales/ar.json';

// Check if we're in development mode
const isDevelopment = process.env.NODE_ENV === 'development';

// Configure i18next
i18n
  // Detect user language
  .use(LanguageDetector)
  // Pass the i18n instance to react-i18next
  .use(initReactI18next)
  // Initialize i18next
  .init({
    // Default language
    fallbackLng: 'en',
    // Debug mode enabled in development only
    debug: isDevelopment,
    // Available languages
    supportedLngs: ['en', 'fr', 'ar'],
    // Namespace
    defaultNS: 'common',
    // Resources/translations
    resources: {
      en: {
        common: enTranslation,
      },
      fr: {
        common: frTranslation,
      },
      ar: {
        common: arTranslation,
      }
    },
    interpolation: {
      escapeValue: false, // React already escapes by default
    },
    // Direction management
    react: {
      useSuspense: true,
    },
    detection: {
      order: ['localStorage', 'navigator'],
      // Disable caching in development mode
      caches: isDevelopment ? [] : ['localStorage'],
    },
    // Reload behavior
    load: 'currentOnly',
    // Development-specific settings
    ...(isDevelopment && {
      // These settings help during development to always get fresh translations
      saveMissing: false,
      updateMissing: false,
      missingKeyHandler: undefined,
      parseMissingKeyHandler: undefined,
    }),
  });

// Create a function to force reload translations
(i18n as any).refreshTranslations = () => {
  // Clear any cached translations in development mode
  if (isDevelopment && typeof window !== 'undefined') {
    const lngKeys = Object.keys(localStorage).filter(key => key.startsWith('i18next_'));
    lngKeys.forEach(key => localStorage.removeItem(key));
    
    // Log only in development
    console.log('Translation cache cleared');
  }
  
  // Force i18next to reload translations
  return i18n.reloadResources().then(() => {
    if (isDevelopment) {
      console.log('Translations reloaded successfully');
    }
  });
};

// Handle RTL/LTR direction based on language
i18n.on('languageChanged', (lng) => {
  const direction = lng === 'ar' ? 'rtl' : 'ltr';
  document.documentElement.lang = lng;
  document.documentElement.dir = direction;
  document.body.dir = direction;
  
  // Force reload translations on language change
  setTimeout(() => {
    (i18n as any).refreshTranslations();
  }, 100);
});

export default i18n; 